module.exports = __webpack_public_path__ + "static/media/id-verified.747772ef.jpg";